module.exports = __webpack_public_path__ + "static/media/mode.1f04573b.png";